import type { InputHTMLAttributes, ReactElement, ReactNode } from 'react';
import styles from './Switch.module.scss';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'role' | 'onChange' | 'checked'> {
  label: ReactNode;
  checked: boolean;
  /** Переключатель действует сразу: колбэк получает новое состояние. */
  onChange(checked: boolean): void;
}

/** Переключатель «вкл/выкл», который применяется сразу (role="switch"), — в отличие от флажка формы. */
export function Switch({ label, checked, onChange, disabled, ...rest }: SwitchProps): ReactElement {
  return (
    <label className={disabled ? `${styles.switch} ${styles.disabled}` : styles.switch}>
      <input {...rest} type="checkbox" role="switch" className={styles.input} checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />
      <span className={styles.track} aria-hidden>
        <span className={styles.thumb} />
      </span>
      <span className={styles.label}>{label}</span>
    </label>
  );
}
